import axios from 'api/axios'
import { Invoice } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for updating an invoice
 */

export interface UpdateInvoiceBody {
	/**
	 * dueDate can't be less than today
	 */
	dueDate: string
	deactivation: boolean
	createdAt: string
	amount: number
	number: string
	url: string
	tdsEnabled: boolean
}

export interface UpdateInvoiceParams {
	id: string
	body: UpdateInvoiceBody
}

/**
 * API call update and invoice
 * @param params UpdateInvoiceParams - data to be send to backend for update an invoice
 * @returns Invoice - Response object returned from the server
 */

export const updateInvoice = async (params: UpdateInvoiceParams) => {
	try {
		const { id, body } = params

		const { data } = await axios.patch<Invoice>(`client/bill/invoice/${id}`, body)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default updateInvoice
